import {roomMeetingNoteApi} from "@/core/api/room.meetingNote.api";

export default {
    startMeetingNote: async ({dispatch, commit, getters, rootGetters},) => {
        
        try {
            await roomMeetingNoteApi.startMeetingNote({title: ''});
        } catch(e) {
            let message = e instanceof Error ? e.message : e;
            console.warn('# Failed to start meeting note', message);
            throw e;
        }
    },
    stopMeetingNote: async ({dispatch, commit, getters, rootGetters}, {meetingNoteId}) => {
        try {
            await roomMeetingNoteApi.stopMeetingNote({meetingNoteId});
        } catch(e) {
            let message = e instanceof Error ? e.message : e;
            console.warn('# Failed to stop meeting note', message);
            throw e;
        }
    },
    initMeetingNote: async ({dispatch, commit, getters, rootGetters}, {meetingNoteId}) => {
        try {
            const meetingNote = getters.meetingNote({meetingNoteId})
            if(!meetingNote || meetingNote.stt) return
            
            const data = await roomMeetingNoteApi.getMeetingNote({meetingNoteId});
            commit('MEETING_NOTE_STT_INIT', {meetingNoteId, data})
        } catch(e) {
            let message = e instanceof Error ? e.message : e;
            console.warn('# Failed to stop meeting note', message);
            throw e;
        }
    },
    deleteMeetingNote: async ({dispatch, commit, getters, rootGetters}, {meetingNoteId}) => {
        try {
            await roomMeetingNoteApi.deleteMeetingNote({meetingNoteId});
        } catch(e) {
            let message = e instanceof Error ? e.message : e;
            console.warn('# Failed to delete meeting note', message);
            throw e;
        }
    },
    getMeetingNote: async ({dispatch, commit, getters, rootGetters}, data) => {
        try {
            return await roomMeetingNoteApi.getMeetingNote(data);
        } catch(e) {
            let message = e instanceof Error ? e.message : e;
            console.warn('# Failed to get meeting note', message);
            throw e;
        }
    },
    summarizeMeetingNote: async ({dispatch, commit, getters, rootGetters}, data) => {
        try {
            await roomMeetingNoteApi.summarizeMeetingNote(data);
        } catch(e) {
            let message = e instanceof Error ? e.message : e;
            console.warn('# Failed to summarize meeting note', message);
            throw e;
        }
    },
    getMeetingNoteSummary: async ({dispatch, commit, getters, rootGetters}, data) => {
        try {
            if(!data.summary){
                const {summary} = await roomMeetingNoteApi.getMeetingNoteSummary(data);
                commit('UPDATE_MEETING_NOTE_SUMMARY', {...data, summary})
            }
            return data;
        } catch(e) {
            let message = e instanceof Error ? e.message : e;
            console.warn('# Failed to get meeting note summary', message);
            throw e;
        }
    },
}
